/**
 *
 * @param {string | undefined} [target]
 * @returns {string | undefined}
 */
const createLinkRel = (target) => {
  const rel = target === '_blank' ? 'noreferrer noopener' : undefined;
  return rel;
};

export default createLinkRel;
